
import axios from '../config/axios';

export const url = '/api/contactochambmetro46fke'


export const createcontactochambmetro46fke = ({
  token,
	dniqf9ni,
	nombrefby5q,
	correor297r,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token && dniqf9ni && correor297r ) {

    axios.post(`${url}//create/basic/6910e767e307249250074325`, {
		dniqf9ni,
		nombrefby5q,
		correor297r,

    }, {
      headers: {
        
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else if (!dniqf9ni) {
		reject({
			status: 'error',
			info: 'DNI no esta definido',
		});
	}  else if (!correor297r) {
		reject({
			status: 'error',
			info: 'Correo no esta definido',
		});
	}  else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      

